import { useMediaQuery } from '@mui/material/';

export enum WebLocation {
    MENU = 'MENU',
    FLOW = 'FLOW',
}

export enum SizeType {
    WIDTH_MAX = 'max-width',
    HEIGHT_MAX = 'max-height',
    WIDTH_MIN = 'min-width',
    HEIGHT_MIN = 'min-height',
}

export interface Breakpoint {
    isTabletSize: boolean;
    isMobileSize: boolean;
    canDisplayMap: boolean;
    aboveAll: boolean;
    isLargeDesktop: boolean;
}

export const MIN_SIZE_PHONE = 320;

export function useSpecificSize(size: string, sizeType: SizeType = SizeType.WIDTH_MAX): boolean {
    return useMediaQuery(`(${sizeType}: ${size})`);
}

/**
 * Different breakpoints for the web application depending on the location
 * @param location Menu or Flow - default to Flow
 * @returns isTabletSize, isMobileSize, canDisplayMap, aboveAll, isLargeDesktop
 */
export function useBreakpoints(location: WebLocation = WebLocation.MENU): Breakpoint {
    const isDesktop720Size = useMediaQuery(`(max-width: ${location === WebLocation.MENU ? '1450' : '1650'}px)`); // les chiffres pour le flow sont à définir (before : 1200)
    const isTabletSize = useMediaQuery(`(max-width: ${location === WebLocation.MENU ? '900' : '1100'}px)`); // les chiffres pour le flow sont à définir (before : 1200)
    const isMobileSize = useMediaQuery(`(max-width: ${location === WebLocation.MENU ? '600' : '700'}px)`); // les chiffres pour le flow sont à définir (before : 900)
    const canDisplayMap = useMediaQuery(`(min-height: 700px)`);

    return {
        isTabletSize,
        isMobileSize,
        canDisplayMap: !isMobileSize || canDisplayMap,
        aboveAll: !isTabletSize && !isMobileSize,
        isLargeDesktop: !isTabletSize && !isMobileSize && !isDesktop720Size,
    };
}
